import { TransactionInfoProvider } from '../TransactionInfoProvider';
import { Headers } from '../types';
import { ApiClientFactory, ApiClientFactoryInterface } from './clients';

export class TransactionInfoProviderFactory {
  private readonly apiClientFactory: ApiClientFactoryInterface;

  constructor(baseUrl: string, headers: Headers) {
    this.apiClientFactory = new ApiClientFactory(`${baseUrl}/api/v1/transaction-info`, headers);
  }

  public createTransactionInfoProvider(token: string): TransactionInfoProvider {
    return new TransactionInfoProvider(this.apiClientFactory.createAuthorizedClient(token));
  }
}
